export default __webpack_public_path__ + "static/media/header-back-image.a134963d.png";